// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__quk6Y","personImg":"Footer_personImg__4L0VG","ul":"Footer_ul__+B7Wq","li":"Footer_li__1LXMl","img":"Footer_img__nwazn","ulGrid":"Footer_ulGrid__RPCUZ"};